export default {
  title: "Contactpersonen",

  table: {
    noData: "Nog geen personen gekoppeld",
  },

  input: {
    title: "Contactpersoon {{action}}",
    contact: {
      label: "Contactpersoon",
    },
    type: {
      label: "Type connectie"
    },
  },
}
